<template>
  <section class="savePage">
   <Header />
    <div class="container">
      <div class="row">
        <div class="savePage__title">
          <span v-if="!isShowLink">Save object in system</span>
          <span v-else>The project was successfully saved in the system</span>
        </div>
      </div>
      <div class="row" v-if="!isShowLink">
        <div class="savePage__form-wrapper">
          <div class="item">
            <form
              @submit.prevent="checkForm" novalidate="true">
              <div class="input__wrapper" :class="{ 'form-group--error': $v.objectName.$error }">
                <div class="input__wrapper-label form__label">Object name</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.objectName.required">This field is required</div>
                  <div class="error" v-if="!$v.objectName.minLength">
                    Name must be longer than {{$v.objectName.$params.minLength.min}} characters
                  </div>
                  <input class="form__input" v-model.trim="$v.objectName.$model"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.adress.$error }">
                <div class="input__wrapper-label form__label">Object address</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.adress.required">This field is required</div>
                  <div class="error" v-if="!$v.adress.minLength">
                    Address must be longer than {{$v.adress.$params.minLength.min}} characters</div>
                  <input class="form__input" v-model.trim="$v.adress.$model"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userName.$error }">
                <div class="input__wrapper-label form__label">Full name</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userName.required">This field is required</div>
                  <div class="error" v-if="!$v.userName.minLength">
                    Name must be longer than {{$v.userName.$params.minLength.min}} characters</div>
                  <input class="form__input" v-model.trim="$v.userName.$model"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userEmail.$error }">
                <div class="input__wrapper-label form__label">Email</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userEmail.required">This field is required</div>
                  <div class="error" v-if="!$v.userEmail.email">
                    Email is not valid</div>
                  <input class="form__input" v-model.trim="$v.userEmail.$model"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userPhone.$error }">
                <div class="input__wrapper-label form__label">Phone</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userPhone.required">This field is required</div>
                  <div class="error" v-if="!$v.userPhone.minLength">
                    Phone must be longer than
                    {{$v.userPhone.$params.minLength.min}} characters</div>
                  <input class="form__input" type="number" v-model.number="$v.userPhone.$model"/>
                </div>
              </div>
              <div class="input__wrapper">
                <div class="input__wrapper-label">
                  Company
                </div>
                <div class="input__wrapper-input">
                  <input type="text" v-model="company" placeholder="">
                </div>
              </div>
              <div class="form-checkbox">
                <input type="checkbox"
                       class="checkbox"
                       id="form-privacy"
                       v-model="$v.privacy.$model">
                <label for="form-privacy" class="tick"></label>
                <label for="form-privacy"
                       :class="{'checkbox-label': true,
                              'checkbox-label--error': $v.privacy.$error}">
                  I agree to the processing and storage of my personal data. <br>
                  By pressing "Save calculation" button, herein I declare that I have read the
                  <a href="https://en.technonicol.eu/company/privacy/" target="_blank">TECHNONICOL
                    Corporation Privacy Policy</a> and agree to process my personal data
                  provided above.
                </label>
              </div>
              <div class="info__wrapper-box info__wrapper-box--form">
                <img src="@/assets/img/info-result.svg" alt="i" class="info__wrapper-img">
                <div class="info__wrapper-text">
                  {{ infoContent }}
                </div>
              </div>
              <div class="captcha">
                <div class="captcha__layout" ref="captcha"></div>
                <div class="captcha__error" v-if="isCaptchaErrorShow">
                  Confirm that you are not a robot
                </div>
              </div>
            <button type="submit" class="btn" :disabled="isBtnDisabled">
              <span>Save calculation</span>
              <img src="@/assets/img/cloud.svg" alt="cloud">
            </button>
            </form>
          </div>
          <div class="item info__wrapper">
            <div class="info__wrapper-box info__wrapper-box--outer">
              <img src="@/assets/img/info-result.svg" alt="i" class="info__wrapper-img">
              <div class="info__wrapper-text">
                {{ infoContent }}
              </div>
            </div>
            <router-link to="/result/" class="btn__back">
            <svg width="26" height="29" viewBox="0 0 26 29"
            fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 13.6667V3.66667C24 2.75 23.2929 2 22.4286 2H3.57143C2.70714 2 2 2.75 2
                      3.66667V13.6667M24 13.6667H2M24 13.6667L23.9999 25.3333C23.9999 26.2499
                      23.2928 26.9999 22.4285 26.9999L16.143 27M24 13.6667L16.143 13.6666M2
                      13.6667L9.07143 13.6666M2 13.6667V20.3333M9.07143 13.6666V20.3333M9.07143
                      13.6666H16.143M9.07143 20.3333H2M9.07143 20.3333V27M9.07143 20.3333H16.143M2
                      20.3333V25.3333C2 26.25 2.70714 27 3.57143 27H9.07143M9.07143 27H16.143M16.143
                      13.6666V20.3333M16.143 13.6666V27M16.143 20.3333V27" stroke="#E30713"
                      stroke-width="3" stroke-miterlimit="22.9256" stroke-linecap="round"
                      stroke-linejoin="round"></path>
            </svg>
            <span>Back to full calculation</span>
          </router-link>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <div class="copyLink__wrapper">
            <div class="copyLink__wrapper-img">
              <img src="@/assets/img/link.svg" alt="link">
            </div>
            <input type="text" ref="link"
                   :value="`${this.domenName}/result/?object=${this.hashFromDB}`"
                   class="copyLink__wrapper-input" readonly="readonly">
            <button @click="copy()" class="copyLink__wrapper-btn">
              copy <span>link</span>
            </button>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <div class="info__wrapper-box info__wrapper-box--save">
            <img src="@/assets/img/info-result.svg" alt="i" class="info__wrapper-img">
            <div class="info__wrapper-text">
              A link to the current version of the project was sent to your mail. Please notice
              that if you make further changes to the project, you will be provided with a new
              link after saving.
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <router-link to="/result/" class="btn__back btn__back-save">
              <svg width="26" height="29" viewBox="0 0 26 29"
              fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 13.6667V3.66667C24 2.75 23.2929 2 22.4286 2H3.57143C2.70714 2 2 2.75 2
                        3.66667V13.6667M24 13.6667H2M24 13.6667L23.9999 25.3333C23.9999 26.2499
                        23.2928 26.9999 22.4285 26.9999L16.143 27M24 13.6667L16.143 13.6666M2
                        13.6667L9.07143 13.6666M2 13.6667V20.3333M9.07143 13.6666V20.3333M9.07143
                        13.6666H16.143M9.07143 20.3333H2M9.07143 20.3333V27M9.07143 20.3333H16.143M2
                        20.3333V25.3333C2 26.25 2.70714 27 3.57143 27H9.07143M9.07143
                        27H16.143M16.143
                        13.6666V20.3333M16.143 13.6666V27M16.143 20.3333V27" stroke="#E30713"
                        stroke-width="3" stroke-miterlimit="22.9256" stroke-linecap="round"
                        stroke-linejoin="round"></path>
              </svg>
              <span>Back to full calculation</span>
            </router-link>
            <button @click="newCalculate()" class="btn__back btn__back-save">
              <svg width="26" height="15" viewBox="0 0 26 15"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.91124 7.53846L26.1428 7.53846M8.45861 1.07692L2.14282
                      7.53846L8.45861 14" stroke="#E30713"
                      stroke-width="2" stroke-miterlimit="22.9256"></path>
                <rect x="3.98901" y="8.46155" width="0.923077"
                      height="1.84615" transform="rotate(180 3.98901 8.46155)"
                      fill="#E30713"></rect>
              </svg>
              <span>Start new caculation</span>
            </button>
        </div>
      </transition>
    </div>
    <Footer />
  </section>
</template>

<script>

import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import {
  required, minLength, email, sameAs,
} from 'vuelidate/lib/validators';
import { dataLayerPushEvent } from '@/utils/GTM';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
  data() {
    return {
      isCaptchaPassed: false,
      isCaptchaErrorShow: false,
      isBtnDisabled: false,
      domenName: '',
      hashFromDB: '',
      isHover: false,
      adress: '',
      objectName: '',
      company: '',
      userName: '',
      userPhone: '',
      userEmail: '',
      privacy: false,
      isShowLink: false,
      infoContent: 'After saving the object, you will receive an internal link to the project. Use the link at any convenient time, open the project and if necessary make corrections to it. A link to the current version of the project will be sent to you by the specified email.',
    };
  },
  validations: {
    userName: {
      required,
      minLength: minLength(4),
    },
    userPhone: {
      required,
      minLength: minLength(8),
    },
    userEmail: {
      required,
      email,
    },
    adress: {
      required,
      minLength: minLength(6),
    },
    objectName: {
      required,
      minLength: minLength(6),
    },
    privacy: {
      sameAs: sameAs(() => true),
    },
  },
  methods: {
    ...mapMutations({
      RESET_SLOPES: 'RESET_SLOPES',
      addNewSlope: 'addNewSlope',
    }),
    async checkForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // validation no pass
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        // validation pass
        if (this.isCaptchaPassed) {


          dataLayerPushEvent('calc-wedge-insulating-save-form');
          this.isBtnDisabled = true;
          const postData = new URLSearchParams();
          const baseUrl = (process.env.NODE_ENV === 'development') ? 'http://en.tn-calc.industrialmedia.com.ua/action/' : `${window.location.origin}/`;
          postData.append('data', JSON.stringify(this.allSlopes));
          postData.append('category', this.category);
          postData.append('name', this.userName);
          postData.append('objectName', this.objectName);
          postData.append('company', this.company);
          postData.append('phone', this.userPhone);
          postData.append('email', this.userEmail);
          postData.append('address', this.adress);
          postData.append('url', `${window.location.origin}/result/?object=`);
          postData.append('result', JSON.stringify(this.result));
          this.$store.commit('updateUserInfoParam', {param: 'userName', val: this.userName});
          this.$store.commit('updateUserInfoParam', {param: 'userPhone', val: this.userPhone});
          this.$store.commit('updateUserInfoParam', {param: 'userMail', val: this.userEmail});
          this.$store.commit('updateUserInfoParam', {param: 'objectName', val: this.objectName});
          this.$store.commit('updateUserInfoParam', {param: 'objectAdress', val: this.adress});
          this.$store.commit('updateUserInfoParam', {param: 'userCompany', val: this.company});
          axios.post(`${baseUrl}service_api/results_save`, postData)
            .then((response) => {
              // console.log(response);
              this.hashFromDB = response.data;
              this.$store.commit('updateUserInfoParam', {
                param: 'link',
                val: `${this.domenName}/result/?object=${this.hashFromDB}`,
              });
              this.isShowLink = true;
              this.isBtnDisabled = false;
            });
        } else {
          this.isCaptchaErrorShow = true;
        }
      }
    },
    copy() {
      const copyCode = this.$refs.link;
      copyCode.select();
      document.execCommand('copy');
      this.$notify({
        group: 'foo',
        type: 'success',
        title: 'Link copied to clipboard',
      });
    },
    newCalculate() {
      this.RESET_SLOPES();
      this.addNewSlope({ id: 1 });
      this.$router.push('/');
      // location.reload();
    },
  },
  mounted() {
    this.domenName = window.location.origin;
    if (this.allSlopes[0].material === '') {
      this.$router.push('/');
      console.clear();
    } else {
      const { grecaptcha } = window;
      grecaptcha.ready(() => {
        grecaptcha.render(this.$refs.captcha, {
          sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
          'expired-callback': () => {
            this.isCaptchaPassed = false;
          },
          'error-callback': () => {
            this.isCaptchaPassed = false;
          },
          callback: () => {
            this.isCaptchaPassed = true;
            this.isCaptchaErrorShow = false;
          },
        });
      });
    }
    // console.log(this.domenName);
  },
  computed: {
    ...mapState({
      category: state => state.category,
    }),
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    result() {
      return this.$store.getters.getResult;
    },
  },
  components: {
    Header,
    Footer,
  },
};

</script>

<style lang="sass" scoped>
.savePage
  color: $black
  &__title
    font-style: normal
    font-weight: 500
    text-align: left
    +media((padding: (320: rem(43) rem(24) rem(34), 992: rem(50) 0)))
    +media((font-size: (320: rem(20), 960: rem(28))))
    +media((line-height: (320: rem(26), 960: rem(34))))
  &__form
    &-wrapper
      width: 100%
      display: grid
      +media((grid-template-columns: (320: 1fr, 960: 7fr 5fr)))
      +media((padding: (320: 0 rem(24), 960: 0)))
      +media((padding-bottom: (320: rem(32), 768: rem(68))))
      .item
        +media((padding: (320: 0)))
        .captcha
          margin: rem(20) 0
          +media((max-width: (0: rem(272), 360: unset)))
          +media((max-height: (0: rem(70), 360: unset)))
          &__layout
            transform-origin: 0 0
            +media((transform: (0: scale(0.89), 360: none)))
          &__error
            font-size: rem(12)
            color: $red
            text-align: left
        .form-checkbox
          display: flex
          align-items: flex-start
          flex-direction: row
          +media((margin: (320: 0 0 rem(34), 768: rem(34) 0 0)))
          .tick
            background: #ffffff
            height: rem(18)
            width: rem(18)
            border-radius: rem(4)
            flex: 0 0 rem(18)
            border: rem(1) solid #D6D6D6
            cursor: pointer
            display: flex
            justify-content: center
            align-items: center
            transition: .5s
            @media (any-hover: hover)
              &:hover
                &:before
                  opacity: 1
            &:before
              content: url("../assets/img/form-tick--red.svg")
              position: relative
              display: block
              line-height: 0
              pointer-events: none
              opacity: 0
              transition: .5s
          .checkbox
            position: absolute
            pointer-events: none
            display: none
            height: 0
            width: 0
            &:checked
              + .tick
                background: $red
                border-color: $red
                &:before
                  opacity: 1
                  content: url("../assets/img/form-tick.svg")
            &-label
              text-align: left
              font-size: rem(12)
              margin-left: rem(10)
              a
                color: $red
              &--error
                color: red
        .input
          &__wrapper
            width: 100%
            display: flex
            align-items: center
            +media((height: (320: auto, 768: rem(68))))
            +media((flex-direction: (320: column, 768: row)))
            &-label, &-input
              height: 100%
              display: flex
              flex-direction: row
              align-items: center
              background: #F6F6F6
              border: rem(1) solid #ECECEC
              box-sizing: border-box
              border-radius: rem(4) 0 0 rem(4)
            .error
              position: absolute
              top: 0
              width: 100%
              font-size: rem(12)
              font-weight: $main-font
              font-weight: 500
              color: red
              text-align: right
              padding-top: rem(5)
              padding-right: rem(10)
              opacity: 0
            &.form-group--error
              .error
                opacity: 1
            &-label
              text-align: left
              font-style: normal
              font-weight: bold
              line-height: rem(18)
              +media((width: (320: 100%, 768: rem(200))))
              +media((max-width: (320: unset, 768: rem(200))))
              +media((background: (320: transparent, 768: #F6F6F6)))
              +media((padding-left: (320: 0, 768: rem(30))))
              +media((font-size: (320: rem(12), 768: rem(14))))
              +media((padding-bottom: (320: rem(7), 768: 0)))
            &-input
              position: relative
              +media((width: (320: 100%, 768: calc(100% - 200px))))
              +media((margin-bottom: (320: rem(23), 768: 0)))
              //+media((margin-bottom: (320: rem(23), 768: 0)))
              input
                height: 100%
                width: 100%
                border: rem(1) solid
                border-color: transparent
                outline: none
                box-shadow: none
                text-align: left
                font-style: normal
                font-weight: bold
                font-size: rem(14)
                line-height: rem(18)
                color: $black
                caret-color: $red
                transition: .5s
                +media((padding-left: (320: rem(16), 768: rem(25))))
                +media((border-radius: (320: rem(4), 768: 0)))
                +media((height: (320: rem(48), 768: 100%)))
                &:focus, &:hover
                  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12)
      .btn
        background: $green
        box-shadow: none
        outline: none
        border: none
        +media((width: (320: 100%, 768: 50%, 960: 100%)))
        color: #fff
        font-family: $main-font
        font-style: normal
        font-weight: bold
        line-height: rem(22)
        border-radius: rem(4)
        transition: .5s
        padding-left: rem(25)
        padding-right: rem(30)
        height: rem(68)
        margin-top: rem(34)
        cursor: pointer
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        +media((height: (320: rem(64), 768: rem(68))))
        +media((font-size: (320: rem(15), 360: rem(18))))
        &:hover
          background: $green-hover
        &:disabled
          opacity: .5
  .btn
    &__back
      background: transparent
      border: rem(1) solid #C9C9C9
      box-sizing: border-box
      border-radius: rem(4)
      display: flex
      flex-direction: row
      align-items: center
      text-decoration: none
      color: $red
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(20)
      transition: .5s
      font-family: $main-font
      cursor: pointer
      max-width: rem(320)
      +media((margin-right: (320: 0, 688: rem(10))))
      // +media((min-width: (320: 100%, 960: rem(320))))
      +media((margin-top: (320: rem(16), 960: 0)))
      +media((padding-left: (320: rem(17), 360: rem(30))))
      +media((height: (320: rem(64), 768: rem(68))))
      // +media((min-width: (320: 100%, 768: 50%, 992: rem(320))))
      +media((width: (320: 100%, 768: 50%, 960: rem(320))))
      svg
        +media((margin-right: (320: rem(20), 360: rem(28))))
        path, rect
          transition: .5s
      &:hover
        background: $red
        color: #fff
        border-color: $red
        svg
          path
            stroke: #fff
          rect
            fill: #fff
      &-save
        +media((margin-top: (320: rem(32), 708: rem(44))))
        +media((margin-bottom: (320: rem(10), 708: rem(66))))
        &:nth-child(2)
          +media((margin-top: (320: rem(0), 708: rem(44))))
          +media((margin-bottom: (320: rem(48), 708: rem(66))))
  .info
    &__wrapper
      display: flex
      flex-direction: column
      justify-content: space-between
      +media((padding: (320: 0, 960: 0 0 0 rem(80))))
      &-box
        display: flex
        flex-direction: row
        align-items: flex-start
        &--save
          +media((align-items: (320: flex-start, 768: center)))
          +media((padding-top: (320: rem(32), 768: rem(44))))
        &--form
          +media((display: (320: flex, 960: none)))
          +media((padding-top: (768: rem(23))))
        &--outer
          +media((display: (320: none, 960: flex)))
      &-text
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(24)
        text-align: left
        padding-left: rem(20)
  .copyLink
    +media((padding: (320: 0 rem(24), 992: 0)))
    &__wrapper
      //display: flex
      //flex-direction: row
      //align-items: center
      //justify-content: space-between
      display: grid
      overflow: hidden
      background: #FFFFFF
      border: rem(1) solid #ECECEC
      box-sizing: border-box
      border-radius: rem(4)
      width: 100%
      +media((grid-template-columns: (320: 7fr 5fr, 768: 2fr 17fr 5fr)))
      +media((height: (320: rem(48), 768: rem(68))))
      &-img
        width: rem(80)
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        +media((display: (320: none, 768: flex)))
      &-input
        background: none
        box-shadow: none
        border: none
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(18)
        height: 100%
        text-overflow: ellipsis
        // pointer-events: none
        outline: none
        overflow: hidden
        +media((padding: (320: 0 rem(24), 768: 0 rem(24) 0 0)))
        &:disabled
          color: $black
      &-btn
        border: none
        outline: none
        box-shadow: none
        background: $red
        height: 100%
        transition: .5s
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(17)
        color: #FFFFFF
        width: rem(200)
        cursor: pointer
        +media((width: (320: 100%, 768: rem(200))))
        &:hover
          background: $red-hover
        span
          +media((display: (320: none, 768: inline-block)))
.fade-enter-active, .fade-leave-active
  transition: opacity .5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
